import React, { useEffect, useState } from 'react';
import { OC, FONT } from '../constants/index.js';
import { useTheme } from '../constants/index.js';
import { useStore } from '../store/StoreProvider.js';
import OCApi from '../api/client.js';
import { Button, Input } from '../components/ui.js';
import { PageHero, renderSimpleMarkdown } from './contentShared.js';

const PAGE_TITLES = {
    help: 'Help center',
    contact: 'Contact us',
    terms: 'Terms of service',
    privacy: 'Privacy policy',
    guidelines: 'Community guidelines',
};

function SupportPageScreen() {
    const s = useStore();
    const t = useTheme(s.theme);
    const slug = s.route.supportSlug || 'help';
    const [page, setPage] = useState(null);
    const isContact = slug === 'contact';

    useEffect(() => {
        if (isContact) return;
        (async () => {
            try {
                const res = await OCApi.getSupportPage(slug);
                setPage(res.page);
            } catch (err) {
                s.showToast('Page not found', 'x');
                s.go('home');
            }
        })();
    }, [slug, isContact]);

    if (isContact) {
        return React.createElement(ContactScreen, null);
    }

    const title = page?.title || PAGE_TITLES[slug] || 'Support';

    return React.createElement('div', { style: { background: t.bg.page, minHeight: '60vh', paddingBottom: 80 } },
        React.createElement(PageHero, { theme: s.theme, eyebrow: 'Support', title, sub: '' }),
        React.createElement('div', {
            style: { maxWidth: 720, margin: '0 auto', padding: '32px 32px 0', color: t.text.primary, fontFamily: FONT.body }
        }, page ? renderSimpleMarkdown(page.bodyMarkdown) : React.createElement('div', { style: { color: t.text.secondary } }, 'Loading…'))
    );
}

function ContactScreen() {
    const s = useStore();
    const t = useTheme(s.theme);
    const [name, setName] = useState('');
    const [email, setEmail] = useState(s.user?.email || '');
    const [subject, setSubject] = useState('');
    const [body, setBody] = useState('');
    const [busy, setBusy] = useState(false);

    const submit = async () => {
        setBusy(true);
        try {
            await OCApi.submitContact({ name, email, subject, body });
            s.showToast('Message sent — we will reply by email', 'check');
            setBody('');
        } catch (err) {
            s.showToast(err.message || 'Could not send', 'x');
        } finally {
            setBusy(false);
        }
    };

    return React.createElement('div', { style: { background: t.bg.page, paddingBottom: 80 } },
        React.createElement(PageHero, { theme: s.theme, eyebrow: 'Support', title: 'Contact us', sub: 'Questions, partnerships, or feedback — we read every message.' }),
        React.createElement('div', { style: { maxWidth: 520, margin: '0 auto', padding: '0 32px' } },
            React.createElement(Input, { theme: s.theme, label: 'Name', value: name, onChange: setName }),
            React.createElement('div', { style: { height: 12 } }),
            React.createElement(Input, { theme: s.theme, label: 'Email', value: email, onChange: setEmail }),
            React.createElement('div', { style: { height: 12 } }),
            React.createElement(Input, { theme: s.theme, label: 'Subject', value: subject, onChange: setSubject }),
            React.createElement('div', { style: { height: 12 } }),
            React.createElement('label', { style: { fontSize: 13, fontWeight: 600, color: t.text.primary } }, 'Message'),
            React.createElement('textarea', {
                value: body, onChange: (e) => setBody(e.target.value), rows: 5,
                style: {
                    width: '100%', boxSizing: 'border-box', marginTop: 8, padding: 12, borderRadius: 10,
                    border: `1.5px solid ${t.border.base}`, background: t.bg.page, fontFamily: FONT.body,
                }
            }),
            React.createElement(Button, { kind: 'primary', size: 'lg', theme: s.theme, fullWidth: true, onClick: submit, disabled: busy, style: { marginTop: 20 } }, busy ? 'Sending…' : 'Send message')
        )
    );
}

export { SupportPageScreen };
